module.exports = __webpack_public_path__ + "static/media/Tiefling.d27e9dc3.png";